import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useGetOne } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';
import { Commission } from 'types/embedded/commission';

type Props = {
  onClick: (record: Commission) => void;
  id: string;
};

export const OrdersShowCommonInfoTransactionsCommissionChip = ({
  onClick,
  id,
}: Props): JSX.Element => {
  const { data: commission, isLoading: isLoadingCommission } = useGetOne<Commission>(
    Resources.Commissions,
    { id: id || '' },
    {
      enabled: Boolean(id),
    },
  );

  if (isLoadingCommission) {
    return <LinearProgress />;
  }

  if (!commission) {
    return <>{EMPTY_FIELD}</>;
  }

  const getLabel = () => {
    const fix = commission?.rate?.fix ? ` / FIX: ${commission?.rate?.fix}` : '';
    const percent = commission?.rate?.percent ? ` / ${commission?.rate?.percent}%` : '';
    return `${commission?.currency?.alphaCode || ''}${fix}${percent}`;
  };

  return (
    <Chip color="primary" label={getLabel()} onClick={() => onClick(commission)} size="small" />
  );
};
